/** Phone or tablet, including iPadOS which reports itself as a Mac. */
export function isMobileDevice(nav) {
  if (!nav) return false;
  const ua = nav.userAgent || "";
  if (/iPhone|iPad|iPod|Android/i.test(ua)) return true;
  return nav.platform === "MacIntel" && (nav.maxTouchPoints || 0) > 1;
}

function isIOS(nav) {
  const ua = nav.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return true;
  return nav.platform === "MacIntel" && (nav.maxTouchPoints || 0) > 1;
}

/**
 * iPhone and iPad have no page screen share. Android keeps the button when
 * the browser exposes getDisplayMedia. Desktop always does.
 */
export function canScreenShare(nav) {
  if (!nav || isIOS(nav)) return false;
  const getDisplayMedia = nav.mediaDevices?.getDisplayMedia;
  if (typeof getDisplayMedia === "function") return true;
  return !/Android/i.test(nav.userAgent || "");
}
